import { i as i18n } from "./_i18n-e414d464.mjs";
import "./index-64135f7d.mjs";
import "./i18n-35335a5c.mjs";
import { i as isApiResponse } from "./malarkeyTwilioAdapter-1c296255.mjs";
import "./event-socket/malarkeyEventSocketAdapter.es.js";
import "vue";
import "./_debug-8b5c3032.mjs";
import "./otpauth.esm-675c01d0.mjs";
import "./sudo-bad5b55e.mjs";
const resolveMessage = (t, message, context = {}, fields = {}) => {
  if (message.field) {
    context.label = fields[message.field] || t(`fields.${message.field}`);
  }
  return t(message.message, context);
};
const uiHelpers = {
  install(app) {
    if (app.config.globalProperties.$alert) {
      return;
    }
    if (app.config.globalProperties.$alertFromApiResponse) {
      return;
    }
    const swal = app.config.globalProperties.$swal;
    const sounds = app.config.globalProperties.$sounds;
    const { t } = i18n.global;
    const alert = async (titleKeypath, messageKeypath, context = {}) => {
      if (!swal) {
        window.alert(
          [
            titleKeypath ? t(titleKeypath, context) : void 0,
            messageKeypath ? t(messageKeypath, context) : void 0
          ].filter((t2) => "string" === typeof t2).map((t2) => "string" === typeof t2 ? t2.trim() : t2).join("\n").trim()
        );
        return void 0;
      }
      return await swal.fire({
        icon: "error",
        titleText: titleKeypath ? t(titleKeypath, context) : void 0,
        text: messageKeypath ? t(messageKeypath, context) : void 0,
        confirmButtonText: t("$vuetify.confirmEdit.ok"),
        reverseButtons: true,
        didOpen: () => {
          if (sounds) {
            sounds.play("onErrorDialog");
          }
        }
      });
    };
    const alertFromApiResponse = async (response, titleKeypath, context = {}, fields = {}, after) => {
      const title = titleKeypath ? t(titleKeypath, context) : void 0;
      let text;
      if (!isApiResponse(response)) {
        text = t("errors.alertFromApiResponse.not.apiResponse", context);
      } else {
        if (response.errors && response.errors.length) {
          const first = response.errors[0];
          text = resolveMessage(t, first, context, fields);
        }
        if (!text && "string" === typeof response.data) {
          text = resolveMessage(t, { message: response.data }, context, fields);
        }
      }
      if (!text) {
        text = t("errors.alertFromApiResponse.unknown", context);
      }
      if (!swal) {
        window.alert(
          [title, text].filter((t2) => "string" === typeof t2).map((t2) => "string" === typeof t2 ? t2.trim() : t2).join("\n").trim()
        );
        if (after) {
          await after();
        }
        return void 0;
      }
      return await swal.fire({
        icon: "error",
        titleText: title,
        text,
        confirmButtonText: t("$vuetify.confirmEdit.ok"),
        reverseButtons: true,
        didOpen: () => {
          if (sounds) {
            sounds.play("onErrorDialog");
          }
        },
        didClose: () => {
          if (after) {
            after();
          }
        }
      });
    };
    app.provide("alert", alert);
    app.provide("alertFromApiResponse", alertFromApiResponse);
    app.config.globalProperties.$alert = alert;
    app.config.globalProperties.$alertFromApiResponse = alertFromApiResponse;
  }
};
const _ui = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  uiHelpers
}, Symbol.toStringTag, { value: "Module" }));
export {
  _ui as _,
  uiHelpers as u
};
//# sourceMappingURL=_ui-71f9b37c.mjs.map
